// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"90f04301","386":"cd29ce0a","494":"72165b24","498":"2ba0d6b4","520":"1b45a3cf","529":"916008c2","705":"0a3d50d5","881":"78c95c29","935":"7bfd24c8","988":"aaa9a191","991":"f3c9a3e1"}[chunkId] + ".chunk.js";
};